import { render, staticRenderFns } from "./GeneralSummary.vue?vue&type=template&id=f0292ad8&scoped=true&"
import script from "./GeneralSummary.vue?vue&type=script&lang=js&"
export * from "./GeneralSummary.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSummary.vue?vue&type=style&index=0&id=f0292ad8&lang=scss&scoped=true&"
import style1 from "./GeneralSummary.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0292ad8",
  null
  
)

export default component.exports